// src/routes/routes.js
import { createBrowserRouter } from 'react-router-dom';
import App from '../App';
import ElectricityPricing from '../components/ElectricityPricing';
import ElectricityPricingSE1 from '../components/ElectricityPricingSE1';
import ElectricityPricingSE2 from '../components/ElectricityPricingSE2';
import ElectricityPricingSE3 from '../components/ElectricityPricingSE3';
import ElectricityPricingSE4 from '../components/ElectricityPricingSE4';
import HistoricalPricing from '../components/HistoricalPricing';
import TrendsComponent from '../components/TrendsComponent';
import NorwegianElectricityPricing from '../components/NorwegianElectricityPricing';
import DanishElectricityPricing from '../components/DanishElectricityPricing';
import KildenKraftPricing from '../components/KildenKraftPricing';
import BaerumPricing from '../components/BaerumPricing';
import CheapenergyPricing from '../components/CheapenergyPricing';
import CheapDenmarkPricing from '../components/CheapDenmarkPricing';
import CheapSwedenPricing from '../components/CheapSwedenPricing';
import MotalaPricing from '../components/MotalaPricing';
import TomorrowPrices from '../components/TomorrowPrices';
import ActualGenerationDashboard from '../components/ActualGenerationDashboard';
import LoadDashboard from '../components/LoadDashboard';
import NetPositionsDashboard from '../components/NetPositionsDashboard';
import TransmissionFlowsDashboard from '../components/TransmissionFlowsDashboard';
import AIForecastDashboard from '../components/AIForecastDashboard';
import SmartScheduler from '../components/SmartScheduler';
export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: '/',
        element: <ElectricityPricing />,
      },
      {
        path: '/norwegian-prices',
        element: <NorwegianElectricityPricing />,
      },
      {
        path: '/danish-prices',
        element: <DanishElectricityPricing />,
      },
      {
        path: '/se1',
        element: <ElectricityPricingSE1 />,
      },
      {
        path: '/se2',
        element: <ElectricityPricingSE2 />,
      },
      {
        path: '/se3',
        element: <ElectricityPricingSE3 />,
      },
      {
        path: '/se4',
        element: <ElectricityPricingSE4 />,
      },
      {
        path: '/history',
        element: <HistoricalPricing />,
      },
      {
        path: '/trends',
        element: <TrendsComponent />,
      },
      {
        path: '/kilden-kraft',
        element: <KildenKraftPricing />,
      },
      {
        path: '/baerum',
        element: <BaerumPricing />,
      },
      {
        path: '/cheapenergy-denmark',
        element: <CheapDenmarkPricing />,
      },
      {
        path: '/cheapenergy',
        element: <CheapenergyPricing />,
      },
      {
        path: '/cheapenergy-sweden',
        element: <CheapSwedenPricing />,
      },
      {
        path: '/motala',
        element: <MotalaPricing />,
      },
      {
        path: '/imorgon',
        element: <TomorrowPrices />,
      },
      {
        path: '/generation',
        element: <ActualGenerationDashboard />,
      },
      {
        path: '/load',
        element: <LoadDashboard />,
      },
      {
        path: '/net-positions',
        element: <NetPositionsDashboard />,
      },
      {
        path: '/transmission',
        element: <TransmissionFlowsDashboard />,
      },
      {
        path: '/ai-forecast',
        element: <AIForecastDashboard />,
      },
      {
        path: '/smart-scheduler',
        element: <SmartScheduler />,
      },
    ],
  },
]);